export const ADDRESS_MAX_LENGTH = 60;
export const ADDRESS_MIN_LENGTH = 3;

export const ADDRESS_REGEXP =
  // eslint-disable-next-line no-misleading-character-class
  /^[\p{L}0-9 ,./\\'\u02B9\u0027\u02BC\u02C8\u0301\u030D\u05F3\u2018\u2019\u2032\uA78C-]*$/mu;

export const validationAddressRules = {
  pattern: {
    value: ADDRESS_REGEXP,
    message: 'validation.wrongSymbols'
  },
  maxLength: {
    value: ADDRESS_MAX_LENGTH,
    message: 'validation.valueLongerThan60'
  },
  minLength: {
    value: ADDRESS_MIN_LENGTH,
    message: 'validation.valueShorterThan3'
  }
};
